import styled from '@emotion/styled';

export const PostcodeWrap = styled.div`
	width: 100%;
`;
